import ReactDOM from "react-dom/client";
import "react-tooltip/dist/react-tooltip.css";
import "assets/styles/index.css";
import { createBrowserHistory } from "history";

import { HistoryRouter } from "./router";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { QueryClient, QueryClientProvider } from "react-query";
//https://www.npmjs.com/package/react-tooltip

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//https://www.codemzy.com/blog/react-query-cachetime-staletime
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 5, // 5 seconds
      cacheTime: 1000 * 10, // 15 seconds
    },
  },
});
const history = createBrowserHistory();
const container = document.getElementById("root");
if (container) {
  const root = ReactDOM.createRoot(container);
  root.render(
    <HistoryRouter history={history}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </HistoryRouter>
  );
}
reportWebVitals();
